import { SportDataGatewayStream } from "./SportDataGatewayStream";
export var SportDataGatewayStreamInstance = new SportDataGatewayStream();
//# sourceMappingURL=index.js.map